export default __webpack_public_path__ + "static/media/liberum-7.02a38ca3.png";